import React from "react";

export const CheckmarkUncheckedIcon: React.FC<
  React.SVGProps<SVGSVGElement>
> = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
  >
    <path
      d="M9.15244 16.8048C8.09106 16.8048 7.09519 16.604 6.16481 16.2025C5.23431 15.801 4.42494 15.2562 3.73669 14.5681C3.04856 13.8798 2.50375 13.0705 2.10225 12.14C1.70075 11.2096 1.5 10.2137 1.5 9.15235C1.5 8.09097 1.70075 7.0951 2.10225 6.16472C2.50375 5.23422 3.04856 4.42485 3.73669 3.7366C4.42494 3.04847 5.23431 2.50366 6.16481 2.10216C7.09519 1.70066 8.09106 1.49991 9.15244 1.49991C10.2138 1.49991 11.2097 1.70066 12.1401 2.10216C13.0706 2.50366 13.8799 3.04847 14.5682 3.7366C15.2563 4.42485 15.8011 5.23422 16.2026 6.16472C16.6041 7.0951 16.8049 8.09097 16.8049 9.15235C16.8049 10.2137 16.6041 11.2096 16.2026 12.14C15.8011 13.0705 15.2563 13.8798 14.5682 14.5681C13.8799 15.2562 13.0706 15.801 12.1401 16.2025C11.2097 16.604 10.2138 16.8048 9.15244 16.8048ZM9.15244 15.0985C10.8154 15.0985 12.2222 14.5233 13.3729 13.3728C14.5234 12.2222 15.0986 10.8153 15.0986 9.15235C15.0986 7.48935 14.5234 6.08253 13.3729 4.93191C12.2222 3.78141 10.8154 3.20616 9.15244 3.20616C7.48944 3.20616 6.08262 3.78141 4.932 4.93191C3.7815 6.08253 3.20625 7.48935 3.20625 9.15235C3.20625 10.8153 3.7815 12.2222 4.932 13.3728C6.08262 14.5233 7.48944 15.0985 9.15244 15.0985Z"
      fill="#C8C7FF"
    />
  </svg>
);
